import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/agelevels/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/agelevels/${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/agelevels/${id}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/agelevels`, data);
    } else {
      return API.apiClient.put(`/agelevels/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/agelevels/search${query}`);
  }
};
